export default "__VITE_ASSET__b32f2776__"